import http_request from './http_request'
import config from 'config'


function getCustomSlide(slideUID, jwt, xApiKey) {
	const headers = {
		'x-api-key': xApiKey,
	}
	if (jwt) {
		headers.jwt = jwt
	}
	return http_request.get(`${config.api}custom_slides/${slideUID}`)
		.withHeaders(headers)
		.send()
}

function putCustomSlide(slideUID, params, xApiKey) {
	return http_request.put(`${config.api}custom_slides/${slideUID}`)
		.withHeaders({
			'x-api-key': xApiKey,
		})
		.send({...params})
}

function getSlide(customSlideId) {
	return http_request.get(`${config.api}custom_slides/${customSlideId}/slide`)
		.send()
}

export default {
	getCustomSlide,
	putCustomSlide,
	getSlide,
}
